const ValidationError = ({ error, ...rest }) =>
  error ? (
    <p className='text-sm text-red-700' {...rest}>
      {error}
    </p>
  ) : null;

export default ValidationError;
